export default "__VITE_ASSET__cSDNqT_q__"